import { useEffect, useState } from 'react';
import { Button, Container, Tab, Tabs } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { PageMeta } from '../../components/meta/PageMeta';
import { useToast } from '../../context/ToastContext';
import { useGetLocationBySlugQuery } from '../../services/endpoints/places/location';
import { formatResponse, SFCLocation } from '../../types/place.types';
import './FranchiseLayout.css';
import { AboutUsSubpage } from './subpages/aboutUs';
import { AvailableJobsSubpage } from './subpages/availableJobs';
import { InTheNewsSubpage } from './subpages/inTheNews';
import { OurCrewSubpage } from './subpages/ourCrew';
import { TestimonialsSubpage } from './subpages/testimonials';

export const FranchiseLayout = () => {
  const { addToast } = useToast();
  const { slug } = useParams<{ slug: string }>();
  const { data, error, isLoading } = useGetLocationBySlugQuery(slug ?? '');

  const [location, setLocation] = useState<SFCLocation>();

  useEffect(() => {
    if (error) {
      addToast('Error while loading data', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data && data.location) {
      setLocation(formatResponse(data?.location));
    }
  }, [data]);

  return (
    <div className="bg-white franchise-page">
      <PageMeta title="Franchise Opportunities" />
      <Container
        fluid
        className="text-blue bg-header d-flex gradient-background"
      >
        <div className="fruit-background left"></div>
        <div className="d-flex justify-content-center align-items-center fanchise-title-container">
          <h1 className="align-items-center text-center">{location?.title}</h1>
        </div>
        <div className="fruit-background right"></div>
        <Button
            className="bg-orange text-white rounded-circle d-none d-lg-flex align-items-center justify-content-center position-fixed bottom-0 end-0 m-4 shadow-lg"
            style={{ width: 64, height: 64, zIndex: 1030 }}
            href={
              location?.latitude != null && location?.longitude != null
                  ? `/sessions?origin=${location.latitude}_${location.longitude}`
                  : '/sessions'
            }
            target="_blank"
            rel="noopener noreferrer"
            title="Find Our Classes"
            aria-label="Find Our Classes"
        >
          <FaSearch size={24} />
        </Button>
      </Container>

      <Container>
        <div>
          <Tabs
              defaultActiveKey="aboutUs"
              id="franchise-subpage-tabs"
              className="d-flex justify-content-sm-center tabs-container franchise-tabs-sticky mb-3"
          >
            <Tab
              className="tab-button"
              eventKey="aboutUs"
              title="ABOUT US"
            >
              <AboutUsSubpage location={location} />
            </Tab>
            <Tab
              eventKey="inTheNews"
              title="IN THE NEWS"
            >
              <InTheNewsSubpage location={location} />
            </Tab>
            <Tab
              eventKey="testimonials"
              title="TESTIMONIALS"
            >
              <TestimonialsSubpage location={location} />
            </Tab>
            <Tab
              eventKey="ourCrew"
              title="OUR CREW"
            >
              <OurCrewSubpage location={location} />
            </Tab>
            <Tab
              eventKey="availableJobs"
              title="AVAILABLE JOBS"
            >
              <AvailableJobsSubpage location={location} />
            </Tab>
          </Tabs>
        </div>
      </Container>
    </div>
  );
};
